<payee-company-search-bank-account-picker
  [taxNumber]="selectedClient?.tax_number"
  [matchAccountNumber]="bankAccountForm.controls.accountNumber.value"
  (accountSelected)="applyCompanySearchAccount($event)"
></payee-company-search-bank-account-picker>

<form [formGroup]="bankAccountForm">
  <div class="bank-account-block">
    <div class="bank-account-header flex vcenter">
      <button
        payee-icon-button
        class="bank-account-label-edit"
        color="white"
        type="button"
        [isBorderButton]="true"
        (mousedown)="$event.preventDefault()"
        (click)="focusLabelInput(labelInput)"
      >
        <payee-icon name="pencil"></payee-icon>
      </button>
      <input
        #labelInput
        payee-input
        class="bank-account-label-input"
        formControlName="label"
        [maxlength]="labelMaxLength"
        [placeholder]="'CLIENT_BANK_ACCOUNT_EDIT.LABEL_PLACEHOLDER' | translate"
      />
    </div>

    <div class="flex bank-account-box">
      <payee-form-field width="wide">
        <input
          payee-input
          formControlName="accountHolderName"
        />
        <span payee-label>{{ "CLIENT_BANK_ACCOUNT_EDIT.BENEFICIARY_NAME_LABEL" | translate }}</span>
        @if (bankAccountForm.controls.accountHolderName.dirty && !bankAccountForm.controls.accountHolderName.value) {
          <mat-error payee-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </mat-error>
        }
      </payee-form-field>

      <div class="bank-account-number-stack">
        <payee-form-field width="wide">
          <input
            payee-input
            formControlName="accountNumber"
            (input)="formatBankAccount(bankAccountForm.controls.accountNumber)"
          />
          <span payee-label>{{ "CLIENT_BANK_ACCOUNT_EDIT.BBAN_IBAN_LABEL" | translate }}</span>
          @if (bankAccountForm.controls.accountNumber.dirty && bankAccountForm.controls.accountNumber.hasError("required")) {
            <mat-error payee-error>
              {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
            </mat-error>
          }
          @if (bankAccountForm.controls.accountNumber.dirty && bankAccountForm.controls.accountNumber.hasError("pattern")) {
            <mat-error payee-error>
              {{ "ERROR_MESSAGES.INVALID_FORMAT_WITH_EXAMPLE" | translate: { pattern: bankAccountFormatExample } }}
            </mat-error>
          }
        </payee-form-field>

        <payee-form-field width="wide">
          <input
            payee-input
            formControlName="bankName"
          />
          <span payee-label>{{ "CLIENT_BANK_ACCOUNT_EDIT.BANK_NAME_LABEL" | translate }}</span>
          @if (bankAccountForm.controls.bankName.dirty && bankAccountForm.controls.bankName.hasError("required")) {
            <mat-error payee-error>
              {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
            </mat-error>
          }
        </payee-form-field>
      </div>
    </div>
  </div>
</form>

<div
  class="save-icon flex vcenter"
  [class.show]="saveCount > 0"
>
  <img
    alt=""
    src="assets/shared/global-images/icons/dot-green.svg"
  />
  <span>{{ "AUTOSAVE" | translate }}</span>
</div>
